import Authorize from "components/Authorize";
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { invoicePermissionProfile } from "components/Authorize/permissionProfiles/invoicePermissionProfile";
import InvoiceStatusDropdown from "features/invoice/shared/InvoiceStatusDropdown";
import { useUpdateVendorInvoiceStatusMutation } from "../vendorInvoiceSlice";
import { NoteEntityTypes } from "features/notes/notesConsts";
import { VendorInvoiceStatus, VendorInvoiceStatusesList } from "../vendorInvoiceConsts";

const StatusCell = ({ row, updateFunction, filled = false }) => {
    const canApprove = isAuthorized(invoicePermissionProfile.APPROVE_VENDOR_INVOICE)

    const getStatusList = (statusId) => {
        return (canApprove || statusId == VendorInvoiceStatus.APPROVED)
            ? VendorInvoiceStatusesList
            : VendorInvoiceStatusesList.filter(s => s.id != VendorInvoiceStatus.APPROVED);
    }

    const readonlyStatus = (statusId) => {
        const color = VendorInvoiceStatusesList?.find(s => s.id == statusId)?.color;
        return <div style={{ color }}>
            {VendorInvoiceStatusesList?.find(s => s.id == statusId)?.name}
        </div>
    };

    const disabledStatuses = (!!row?.qbVendorId
        && row?.services?.length > 0
        && row.services.every(s => !!s.qbAccountId)) ? [] : [VendorInvoiceStatus.APPROVED];
    const disabledStatusMessage = "Please  populate a QuickBooks vendor and map QuickBooks accounts to all services before approving.";

    const isDisabled = (!!row?.statusId && row.statusId === VendorInvoiceStatus.SENT_TO_QB);

    return (
        <Authorize
            profile={invoicePermissionProfile.EDIT_VENDOR_INVOICE}
            readonlyComponent={
                <div>{readonlyStatus(row?.statusId)}</div>
            }
        >
            <InvoiceStatusDropdown
                invoiceId={row?.id}
                filled={filled}
                noteEntityType={NoteEntityTypes.STORAGEINVOICES}
                invoice={row}
                invoiceStatusList={getStatusList(row?.statusId)}
                updateMutation={useUpdateVendorInvoiceStatusMutation}
                updateFunction={updateFunction}
                disabledStatuses={disabledStatuses}
                disabledStatusMessage={disabledStatusMessage}
                isDisabled={isDisabled}
            />
        </Authorize>
    );
};

export default StatusCell;
